import { useEffect, useState } from 'react'

import { hotjar } from 'react-hotjar'
import { BrowserRouter } from 'react-router-dom'

import { AlertCard } from './components/AlertCard'
import { Button } from './components/Button'
import './styles/global.scss'
import { env } from './configs/env.config'
import { ContextsProviders } from './contexts/ContextsProviders'
import { Routes } from './routes'

function App() {
  const [openCookies, setOpenCookies] = useState(false)
  const [cookiesConsent, setCookiesConsent] = useState<string | null>(null)
  useEffect(() => {
    const hjid = parseInt(env.HOTJAR_ID)
    const hjsv = parseInt(env.HOTJAR_SV)
    hotjar.initialize(hjid, hjsv)
  }, [])

  const setCookiesStorage = (value: string) => {
    localStorage.setItem('_cookiesConsent', value)
    setCookiesConsent(localStorage.getItem('_cookiesConsent'))
  }

  useEffect(() => {
    setCookiesConsent(localStorage.getItem('_cookiesConsent'))
  }, [])

  useEffect(() => {
    if (cookiesConsent && cookiesConsent === 'true') {
      setOpenCookies(false)
    } else {
      setOpenCookies(true)
    }
  }, [cookiesConsent])

  return (
    <BrowserRouter>
      <ContextsProviders>
        <div className="App">
          <Routes />
          <AlertCard
            open={openCookies}
            title="Política de cookies"
            content={
              <p>
                {' '}
                A Blockforce utiliza cookies para melhorar sua navegação e
                experiência.{' '}
                <a href="/cookies" target="_blank">
                  {' '}
                  Política de Cookies.
                </a>
              </p>
            }
            button={
              <Button
                title="Prosseguir"
                fullWidth
                onClick={() => {
                  setCookiesStorage('true')
                }}
              />
            }
          />
        </div>
      </ContextsProviders>
    </BrowserRouter>
  )
}

export default App
